import { render } from "./EditRoleName.vue?vue&type=template&id=d5898362&scoped=true"
import script from "./EditRoleName.vue?vue&type=script&lang=js"
export * from "./EditRoleName.vue?vue&type=script&lang=js"

import "./EditRoleName.vue?vue&type=style&index=0&id=d5898362&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5898362"]])

export default __exports__